import React, { useEffect, useState } from "react";
import SnpComponent from "../global/SnpComponent";
import {
  setUrl,
  AXIOS_TIMEOUT,
  CartDets,
  GETIPADDRESS,
  NODATA,
  NULLDATA,
  SHOPNOTACCESSERROR,
  SSOLOGIN,
  SUCCESS,
  VALIDITYEXPIREDERR,
  detectBrowser,
  getOperatingSystem,
  isEmpty,
  setLoginResponse
} from "../../constants/constant";
import { useDispatch, useSelector } from "react-redux";
import { setActiveShopHash, setApiUrl, setCartType } from "../../actions";
import { Navigate } from "react-router-dom";
import axios from "axios";


export default function SsoLogin() {
    const [isLoader, setLoader] = useState(false);
    const storeApiUrl = useSelector(state => state.setApiUrlReducer.MAINURL.INITIAL_BASE_URL);
    const [isMobile, setIsMobile] = useState(window.matchMedia('(max-width: 767px)').matches);
    const [doNavigate,setDoNavigate] = useState(false);
    const INITIAL_SNP_COMPONENT = {
        showDialog: false,
        outSideClickDismiss: true,
        title: "",
        subTitle: "",
        negativeAction: "",
        positiveAction: "",
        positiveReq: false,
        iconReq: "",
        snackBarOpen: false,
        snackBarMsg: "",
        cancelExtra: false,
        negativeReq: false,
        requestType: 0,
    };
    const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);

    const dispatch = useDispatch();


    const onClose = () => {
        window.opener = null;
        window.open("", "_self");
        window.close();
    };
    useEffect(() => {
        console.log("SSO Login");
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        //var currentTime = +new Date();
        //printLog("useEffect<=",currentTime);
        const handleMediaQueryChange = (event) => {
          setIsMobile(event.matches);
        };
    
        mediaQuery.addEventListener('change', handleMediaQueryChange);
        if (!isMobile) {
            getIpAddress();
        } else {
            setDoNavigate(true);
        }
        return () => {
          mediaQuery.removeEventListener('change', handleMediaQueryChange);
        };
    }, []);


    const getIpAddress = () => {
        let data = {};
        setLoader(true);
        axios.get(GETIPADDRESS,data)
            .then((response) => {
                console.log("getIpAddress:",response.data);
                if (!isEmpty(response.data)) {
                    let baseUrl = setUrl(response.data);
                    setApiUrl(baseUrl);
                    ssoLoginNetworkCall(baseUrl);
                } else {
                    setSnpComponent({
                        ...snpComponent,
                        isLoader: false,
                        negativeReq: true,
                        negativeAction: "Ok",
                        showDialog: true,
                        outSideClickDismiss: false,
                        cancelExtra: true,
                        requestType: 1,
                        subTitle: "Please login from tools first"
                    });
                }
            }).catch((error) => {
                //printLog("error : ", error);
                //window.location.href = "#/error";
                setSnpComponent({
                    ...snpComponent,
                    isLoader: false,
                    negativeReq: true,
                    negativeAction: "Ok",
                    showDialog: true,
                    outSideClickDismiss: false,
                    cancelExtra: true,
                    requestType: 1,
                    subTitle: "Please login from tools first"
                });
            });
    };

    const ssoLoginNetworkCall = (baseUrl) => {
        let catgUrl = baseUrl.BACKEND_BASE_URL + SSOLOGIN;
        console.log("ssoLoginNetworkCall:",catgUrl);
        let data = {
            userEmail: "",
            userPassWord: "",
            apiToken: "",
            deviceName: getOperatingSystem() + "," + detectBrowser(),
        };
        
        axios({
            method: "POST",                 //POST_ACTION
            url: catgUrl,
            data: data,
            timeout: AXIOS_TIMEOUT
        }).then(response => {
            //console.log("responses => ", response.data);
            setLoader(false);
            if (response.data.errCode === SUCCESS) {
                if (response.data.cartType === CartDets.Resto)
                    sessionStorage.setItem('componentIndex', "7");
                else
                    sessionStorage.setItem('componentIndex', "0");
                setLoginResponse(response.data);
                dispatch(setCartType(response.data.cartType));
                dispatch(setActiveShopHash(response.data.activeShopHash));
                onSuccess();
            } else if (response.data.errCode === NODATA) {
                setSnpComponent({
                    ...snpComponent,
                    isLoader: false,
                    negativeReq: true,
                    negativeAction: "Ok",
                    showDialog: true,
                    outSideClickDismiss: false,
                    cancelExtra: true,
                    requestType: 1,
                    subTitle: "Please login from tools first"
                });
            } else if (response.data.errCode === VALIDITYEXPIREDERR) {
                setSnpComponent({
                    ...snpComponent,
                    isLoader: false,
                    negativeReq: true,
                    negativeAction: "Ok",
                    showDialog: true,
                    outSideClickDismiss: false,
                    cancelExtra: true,
                    requestType: 1,
                    subTitle: "Your Validity is Expired!Contact SNP Administrator"
                });
            } else if (response.data.errCode === NULLDATA) {
                setSnpComponent({
                    ...snpComponent,
                    isLoader: false,
                    negativeReq: true,
                    negativeAction: "Ok",
                    showDialog: true,
                    outSideClickDismiss: false,
                    cancelExtra: true,
                    requestType: 1,
                    subTitle: "Please login from tools first"
                });
            } else if (response.data.errCode === SHOPNOTACCESSERROR) {
                setSnpComponent({
                    ...snpComponent,
                    isLoader: false,
                    negativeReq: true,
                    negativeAction: "Ok",
                    showDialog: true,
                    outSideClickDismiss: false,
                    cancelExtra: true,
                    requestType: 1,
                    subTitle: "This shop is not accessible to you"
                });
            }
            
        }).catch(error => {
            console.log("error : ", error);
            setLoader(false);
            setSnpComponent({
                ...snpComponent,
                isLoader: false,
                negativeReq: true,
                negativeAction: "Ok",
                showDialog: true,
                outSideClickDismiss: false,
                cancelExtra: true,
                requestType: 1,
                subTitle: "Please start the app engine"
            });
            
            //window.location.href = "#/error";
        });
    }

    const onSuccess = () => {
        setIsSubmitted(true);
    }
    const [isSubmitted, setIsSubmitted] = useState(false);

    const renderSnpContent = () => {
        return (
            <>{!isSubmitted ? doNavigate ? <Navigate replace to="/login" /> :  <div><h2>Spark N Pass Next Gen Pvt Ltd SSO Call</h2></div>  : <Navigate replace to="/dashboard" />}</>
        );
    };

    return (
        <React.Fragment>
            <SnpComponent
                content={renderSnpContent()}
                showDialog={snpComponent.showDialog}
                isLoader={isLoader}
                title={snpComponent.title}
                subTitle={snpComponent.subTitle}
                negativeAction={snpComponent.negativeAction}
                positiveReq={snpComponent.positiveReq}
                positiveAction={snpComponent.positiveAction}
                negativeReq={snpComponent.negativeReq}
                handleDialogClose={onClose}
                iconReq={snpComponent.iconReq}
                cancelExtra={snpComponent.cancelExtra}
                onCancel={onClose}
                snackBarOpen={snpComponent.snackBarOpen}
                snackBarMsg={snpComponent.snackBarMsg}
                outSideClickDismiss={snpComponent.outSideClickDismiss}
                
            />
        </React.Fragment>
    );
}
